import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {replace, get} from 'lodash';
import {TranslateModule} from '@ngx-translate/core';
import {
  additionalPaletteSticker,
  stickerCSSClassMapper
} from '../../../shared/constants/color-picker.constants';
import {GraphActionsService} from '../../../diagram-interaction/actions/graph-actions.service';
import {ColorPickerComponent} from '../../shared/color-picker/color-picker.component';
import {DraggableDialogDirective} from '../../shared/directives/draggable-dialog.directive';

@Component({
  selector: 'app-change-sticker-color-dialog',
  templateUrl: './change-sticker-color-dialog.component.html',
  standalone: true,
  imports: [ColorPickerComponent, TranslateModule, MatDialogModule, DraggableDialogDirective]
})
export class ChangeStickerColorDialogComponent implements OnInit {
  public palette = additionalPaletteSticker;

  private mxKey;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private graphActionsService: GraphActionsService
  ) {}

  ngOnInit(): void {
    this.mxKey = this.data?.cell?.id;
  }

  public changeBackgroundColor(event: string) {
    const color = replace(event, '#', '');
    const stickerCSSClass = get(stickerCSSClassMapper, color, 'FAF8E5');

    return this.graphActionsService.setStickerStyle(stickerCSSClass, this.mxKey);
  }
}
